<template>
  <span v-if="showTooltip" :id="id" class="tooltip">
    <span class="tooltip-icon" />
    <span class="tooltip-bubble" v-html="content" />
  </span>
</template>
<script>
export default {
  name: 'Tooltip',
  props: {
    content: {
      type: String,
      default() {
        return null;
      }
    },
    id: {
      type: String,
      default() {
        return '';
      }
    }
  },
  computed: {
    showTooltip() {
      return this.content !== null && this.content !== '';
    }
  },
  mounted() {
    const tooltipElm = this.$el;
    this.moveBubbleArrowToIcon('50%');

    tooltipElm.addEventListener('mouseover', () => {
      this.tooltipBubbleCheckPosition(tooltipElm);
    });

    tooltipElm.addEventListener('click', () => {
      this.tooltipBubbleCheckPosition(tooltipElm);
    });
  },
  methods: {
    tooltipBubbleCheckPosition(elm) {
      const bubbleElm = elm.querySelector('.tooltip-bubble');
      const tooltipDefaultLeft = -142;

      this.resetToolTipPosition(elm);

      const bubbleBoundingClientRect = bubbleElm.getBoundingClientRect();
      const viewportOffsetBubbleLeft = bubbleBoundingClientRect.left;
      const viewportOffsetBubbleLeftToPositive = Math.abs(viewportOffsetBubbleLeft);
      const viewportOffsetBubbleRight = bubbleBoundingClientRect.right;
      const viewportOffsetBubbleTop = bubbleBoundingClientRect.top;

      const iconElm = elm.querySelector('.tooltip-icon');
      const iconBoundingClientRect = iconElm.getBoundingClientRect();
      const viewportOffsetIconLeft = iconBoundingClientRect.left;

      const windowWidth = window.innerWidth;
      const offsetMargin = 10;
      const defaultBubbleWidth = 300;
      const bubbleWidth =
        windowWidth < defaultBubbleWidth + 2 * offsetMargin ? windowWidth - 2 * offsetMargin : 300;

      if (windowWidth < defaultBubbleWidth + 2 * offsetMargin) {
        bubbleElm.style.width = bubbleWidth + 'px';
      }

      if (viewportOffsetBubbleTop < 0) {
        elm.classList.add('lower');
      }

      if (viewportOffsetBubbleLeft < offsetMargin) {
        bubbleElm.style.left =
          tooltipDefaultLeft + viewportOffsetBubbleLeftToPositive + offsetMargin + 'px';
        this.moveBubbleArrowToIcon(viewportOffsetIconLeft + 'px');
      }

      if (viewportOffsetBubbleRight > windowWidth) {
        const tooltipBubbleOffsetLeft =
          tooltipDefaultLeft - (viewportOffsetBubbleRight - windowWidth) - offsetMargin;
        bubbleElm.style.left = tooltipBubbleOffsetLeft + 'px';
        this.moveBubbleArrowToIcon(Math.abs(tooltipBubbleOffsetLeft) + offsetMargin + 'px');
      }
    },
    moveBubbleArrowToIcon(leftPos) {
      document.documentElement.style.setProperty('--arrow-left', leftPos);
    },
    removeTooltipInlineStyle() {
      const tooltipArray = document.querySelectorAll('.tooltip-bubble');
      tooltipArray.forEach((element) => element.removeAttribute('style'));
    },
    resetToolTipPosition(elm) {
      this.removeTooltipInlineStyle();
      elm.classList.remove('lower');
      this.moveBubbleArrowToIcon('50%');
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../styles/all.scss';
@import '../../styles/typography/_icons';

.tooltip,
[data-tooltip] {
  position: relative;
  vertical-align: middle;
  margin-left: 5px;

  .tooltip-icon {
    &::before {
      content: '\30';
      font-family: $icon;
      font-size: rem-calc(16);
      color: $dark-gray;
      cursor: pointer;
    }
  }

  .tooltip-bubble {
    font-family: $body-font-family;
    font-size: rem-calc(15);
    line-height: 1.5em;
    visibility: hidden;
    width: 300px;
    background-color: $tooltip-background-color;
    color: $tooltip-color;
    border-radius: $tooltip-radius;
    padding: $tooltip-padding;
    position: absolute;
    z-index: 1000;
    bottom: 33px;
    left: -142px;
    opacity: 0;
    transition: opacity 0.3s;

    &::after {
      content: '';
      position: absolute;
      bottom: -16px;
      left: var(--arrow-left);
      margin-left: -8px;
      border-width: 8px;
      border-style: solid;
      border-color: $tooltip-background-color transparent transparent transparent;
    }
  }

  &:hover {
    .tooltip-bubble {
      visibility: visible;
      opacity: 1;
    }
  }

  &.lower {
    .tooltip-bubble {
      bottom: auto;
      top: 33px;

      &::after {
        bottom: auto;
        top: -16px;
        transform: rotate(180deg);
      }
    }
  }
}
</style>
